import { Box } from '@mui/material';
import { axisClasses, BarChart } from '@mui/x-charts';
import { valueFormatter } from 'pages/DashboardPageClient/datasDash';
import { ChartPoint } from 'services/Dashboard/types';

interface BarChartWeakProps {
  data?: ChartPoint[];
}

const BarChartWeak = ({ data = [] }: BarChartWeakProps) => {

  const chartSetting = {
    width: 1000,
    height: 400,
    sx: {
      [`.${axisClasses.left} .${axisClasses.label}`]: {
        transform: 'translate(-20px, 0)',
      },
    },
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#202940',
        width: '100%',
        height: '100%',
        padding: 2,
        borderRadius: 3,
        boxShadow: '0 4px 24px rgba(0,0,0,0.25)',
      }}
    >
      <BarChart
        dataset={data}
        xAxis={[{ scaleType: 'band', dataKey: 'label' }]} // Label vindo do backend (ex: 15/12)
        series={[
          {
            dataKey: 'value',
            label: 'Eventos por Semana',
            valueFormatter: (value) => valueFormatter ? valueFormatter({ value: value ?? 0 }) : `${value}`,
          },
        ]}
        {...chartSetting}
      />
    </Box>
  );
};

export default BarChartWeak;
